<template>
  <div>
    <div id="progress"></div>
    <div class="resume-editor" ref="editorFrom">
      <h1>发布招聘职位</h1>
      <div>
        <!-- 基础信息 -->
        <div class="resumeSection">
          <div>
            <h2 class="resumeSection__title">职业信息</h2>
          </div>
          <div class="resumeSection__form">
            <!-- <el-form
              :model="{
                name: resume.name,
                email: resume.email,
                mobile_number: resume.mobile_number,
              }"
              :rules="validatorRules.basic"
              ref="basicForm"
            >
              <el-form-item label="姓名" prop="name">
                <el-input v-model="resume.name"></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="mobile_number">
                <el-input v-model="resume.mobile_number"></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="resume.email"></el-input>
              </el-form-item>
            </el-form> -->
            <el-form>
                <el-form-item label="职业名称">
                    <el-select v-model="jobName" filterable placeholder="请选择">
                        <el-option v-for="item in jobNameOptions"  :key="item.id" :label="item.name" :value="item.name"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证书航区">
                    <el-select v-model="zsHq" filterable placeholder="请选择">
                        <el-option v-for="item in zsHqOptions"  :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证书等级">
                    <el-select v-model="zsL" filterable placeholder="请选择">
                        <el-option v-for="item in zsLOptions"  :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="船型">
                    <el-select v-model="shipType" filterable placeholder="请选择">
                        <el-option v-for="item in shipTypeOptions"  :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="吨位">
                    <el-select v-model="shipTLevel" filterable placeholder="请选择">
                        <el-option v-for="item in shipTLevelOptions"  :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="职位标签">
                    <el-select v-model="tag" multiple placeholder="请选择">
                         <el-option v-for="item in tagOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        


          </div>

        </div>
        <div class="resumeSection">
            <div>
              <h2 class="resumeSection__title"> 职位详情 </h2>
            </div>
            <div> 
                <el-form>

                <el-form-item label="薪资待遇">
                   <el-input placeholder="请输入内容" v-model="salary" oninput ="value=value.replace(/[^0-9.]/g,'')" class="input-with-select">
                        <el-select v-model="select" slot="prepend" placeholder="请选择" style="width:130px">
                            <el-option label="人民币" value="0"></el-option>
                            <el-option label="美元" value="1"></el-option>
                            <el-option label="面议" value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>

                    <el-form-item label="职位详情">
                        <el-input
                            type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="intro">
                            </el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>


        <div class="resumeSection">
          <div>
              <h2 class="resumeSection__title"> 联系人 </h2>
          </div>
          <div> 
              <el-form>
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="contact"></el-input>
                </el-form-item>
              
                <el-form-item label="手机号码" prop="mobile_number">
                    <el-input size="text"  oninput ="value=value.replace(/[^0-9.]/g,'')"  placeholder="请输入内容"  v-model="contactMobile" maxlength="11"  minlength="11" show-word-limit> </el-input>
                </el-form-item>

              </el-form>
          </div>
        </div>
      </div>
    </div>
    <div
      ref="footerAction"
      :class="{ 'resumeEditor-footerAction-fix': footerActionFixed }"
      class="resumeEditor-footerAction" style="text-align: center;"
    >
      <el-button round @click="$router.push('/home')">取消</el-button>
      <el-button round :loading="submitLoading" size="medium" @click.native="submit" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import {
 fetchJobConfig ,
 fetchBossJobCreate
} from "@/helper/requestWithToken.js";
import { state } from "@/store";
import createMessage from "@/components/message";
export default {
  data() {
    return {
        submitLoading: false,
        footerActionFixed: false,
        jobName:'',
        jobNameOptions:[],
        zsHq:'',
        zsHqOptions:[],
        zsL:'',
        zsLOptions:[],
        shipType:'',
        shipTypeOptions:[],
        shipTLevel:'',
        shipTLevelOptions:[],
        tag:'',
        tagOptions:[],
        select:'',
        selectOptions:[],
        salary:'',
        contact:'',
        contactMobile:'',
        intro:'',
      
    }
  },

  methods: {

    submit() {
        console.log("点击按钮");
        this.submitLoading = true; 
        let t;
        for (let index = 0; index < this.tag.length; index++) {
            
            if(index>0){
                t=t+','+this.tag[index];
            }else{
                t = this.tag[index];
            }
            
        }
        let data={
                name:this.jobName,//文字
                intro:this.intro,//文字
                zsLevel:this.zsL,
                zsHq:this.zsHq,
                shipType:this.shipType,
                shipTLevel:this.shipTLevel,
                salary:this.salary,
                contact:this.contact,//文字
                contactMobile:this.contactMobile,
                payType:this.select,
                tag:t
        };


        var res=  fetchBossJobCreate(data)
            .then(res =>{
                console.log(res);
                this.submitLoading = false; 
            })
            .catch(err=>{
                console.log('err'+err);
                this.submitLoading = false; 
            })
   },

    onPageScroll() {
      this.footerActionFixed =
        window.scrollY <
        this.footerActionShouldFixedThreshold - window.innerHeight;
    },
  },
  created() {
    //禁止非登陆用户访问此页面
    if (!state.isLogin  ) {
        console.log("点击投递,用户未登录");
         createMessage.warning("尚未登陆,请登陆后再操作");
       return this.$router.push("/user");
      }
    //禁止非企业用户访问此页面
    if(state.userInfo.identity !='2'){
         createMessage.warning("非企业用户不可访问此页面");
       return  this.$router.push("/home");
    }
    let loading = this.$loading({ position: { top: 60 } });
    // const { id } = this.$route.params;
    fetchJobConfig()
      .then(res => {
         console.log(res.data);
         let data=res.data;
         this.jobNameOptions =data.job_type_list;
         this.zsHqOptions =data.zsHq;
         this.zsLOptions =data.zsL;
         this.shipTypeOptions =data.shipType;
         this.shipTLevelOptions =data.shipTLevel
         this.tagOptions =data.tag;
        // this.companyDetail = res.data;
        // console.log(this.companyDetail.nickname);
        loading.close();
      })
      .catch(loading.close);


  },


  
}
</script>

<style lang="less">
.el-upload {
  width: 100%;
  .uploadFile__works {
    .uploadWorks__fileicon {
      width: 50px;
      height: 50px;
      margin: auto;
    }
    .el-icon-warning {
      font-size: 30px;
    }
  }
  &:focus {
    border-color: inherit;
    color: inherit;
  }
  &-dragger {
    display: table-cell;
    vertical-align: middle;

    border: none;
    background: @bg-base-color;
    width: 600px;
    .upload-button {
      display: inline-block;
      width: 100px;
      margin: 10px 0;
    }

    .afterUpload {
      .fileicon {
        width: 50px;
        height: 50px;
        margin: auto;
      }
      time {
        color: @secondary-text-color;
      }
      &__actionButton {
        color: @main-color;
        &-dividerLine {
          margin: 0 14px;
        }
      }
    }
  }
}
.upload-success-tip {
  display: flex;
  background: @bg-base-color;
  padding: 0 7px;
  align-items: center;
  .el-icon-warning {
    color: @main-color;
  }
  .tips-resolve {
    color: @main-color;
    cursor: pointer;
    margin-left: 6px;
  }
  .el-icon-close {
    cursor: pointer;
    margin-left: auto;
  }
}
// }
.resumeSection {
  .el-select,
  .el-date-editor {
    width: 100%;
  }
  .bottom-action {
    // display: flex;

    .el-icon-plus,
    .el-icon-delete {
      font-size: 22px;
      cursor: pointer;
      &-top {
        margin-left: auto;
      }
    }

    .el-icon-delete {
      margin-left: auto;
    }
  }
  .el-form {
    margin-bottom: 40px;
    &:not(:last-child) {
      border-bottom: 1px solid @border-light-color;
    }
  }
}
</style>

<style lang="less" scoped>
.resume-editor {
  width: 900px;
  margin: auto;
  padding: 30px 0;
}
.resumeEditor-footerAction {
  padding: 30px 190px;
  z-index: 33;
  text-align: right;
  &-fix {
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;

    box-shadow: 0 -2px 10px #eee;
  }
}
.resumeSection {
  padding: 50px 0;
//   display: flex;
  justify-content: space-between;
  border-bottom: 1px solid @border-base-color;

  &__title {
    margin-right: 200px;
    margin-bottom: 20px;

    padding-bottom: 3px;
    border-bottom: 2px solid @main-color;
  }
  &__form {
    width: 600px;
  }
}
</style>
